import { Component, Inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface MotivoDialogData {
  titulo: string;
  mensaje?: string;
  motivoLabel?: string;
}

/**
 * Diálogo genérico para pedir un motivo obligatorio (usado por rechazar registro/registros
 * y por cualquier otra acción que requiera dejar constancia del porqué de un cambio).
 */
@Component({
  selector: 'app-motivo-dialog',
  templateUrl: './motivo-dialog.component.html',
  standalone: false,
})
export class MotivoDialogComponent {
  form: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<MotivoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MotivoDialogData
  ) {
    this.form = new UntypedFormGroup({
      motivo: new UntypedFormControl('', [Validators.required]),
    });
  }

  cancelar(): void {
    this.dialogRef.close(null);
  }

  guardar(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.form.get('motivo').value);
    }
  }
}
